import * as React from 'react';
import { useContext, useEffect } from 'react';
import Logo from '../../components/voxel/Logo/Logo';
import VoxelButton from '../../components/voxel/Buttons/VoxelButton';
import VoxelLink from '../../components/voxel/Link/VoxelLink';
import VoxelText from '../../components/voxel/Text/VoxelText';
import { useUpdateMetaTags } from '../../logic/otherUtilities/useUpdateMetaTags';
import { AuthenticationContext } from '../../logic/security/authentication/AuthenticationContext';
import GoogleLogo from './GoogleLogo';
import VoxelDivider from '../../components/voxel/VoxelDivider';
import UnderlineScribble from './UnderlineScribble';

export interface SignInPageProps { }

const SignInPage: React.FC<SignInPageProps> = ({ }) => {
  const authenticationContext = useContext(AuthenticationContext);

  useEffect(() => {
    const devPrefix = window.location.href.includes('localhost') ? 'Dev | ' : '';
    document.title = `${devPrefix}Voxel – Login`;
  }, []);

  useUpdateMetaTags([
    {
      name: 'description',
      content:
        'Login to your Voxel account here. Use your Google email for a seamless start and take your keyword game to the next level instantly!',
    },
  ]);

  // https://dribbble.com/shots/19338138-Log-in-page-Untitled-UI

  {
    /* 
    By professionals for professionals...
    Streamline your SEO experience...
    From start to finish...We'll get you there.. 
    Everything in one place... Spreadsheet competitor
    Keywords - Ranks - Tags - Competitors - Insights - Crawl - Plan - Track performance
    Early bird gets the worm
  */
  }

  {
    /* <div className='w-full flex flex-row justify-center gap-4'>
    <VoxelLink className='font-semibold font-sans text-voxel-blue'>
      © Voxel Nordic AB
    </VoxelLink>
    <div>·</div>
    <VoxelLink className='font-semibold font-sans text-voxel-blue'>
      Contact
    </VoxelLink>
    <div>·</div>
    <VoxelLink className='font-semibold font-sans text-voxel-blue'>
      Privacy & terms
    </VoxelLink>
  </div> */
  }

  return (
    <div className={`w-full h-screen bg-white grid grid-cols-5`}>
      <div className="h-full w-full p-8 col-span-5 sm:col-span-3 lg:col-span-2">
        <a href="https://www.voxeltool.io">
          <Logo size="xs" />
        </a>
        <div className="mt-48 w-full p-12 flex flex-col justify-center gap-12">
          <div className="w-full flex flex-col items-center gap-12">
            <div className="w-full flex flex-col items-center gap-9">
              <div className="w-full flex flex-col gap-6 items-center">
                <VoxelText
                  variant="title1"
                  className="font-bold tracking-tight"
                  colorClassName="text-voxel-blue"
                >
                  Sign in to your account
                </VoxelText>
                <VoxelText variant="title3" color="light">
                  Use the same Google email as in your invite
                </VoxelText>
              </div>
              <VoxelButton
                shape="square"
                onClick={() => {
                  authenticationContext.signIn();
                }}
                title={
                  <div className="flex flex-row items-center justify-center gap-0.5">
                    <GoogleLogo />
                    <VoxelText variant="bread-semibold">Log in with Google</VoxelText>
                  </div>
                }
                size="xl"
                color="transparent"
                className="border border-2 border-voxel-blue w-[352px]"
              />
            </div>
            <div>
              <VoxelText>
                Don't have an account?
                <VoxelLink
                  href={'/register'}
                  className="pl-2 font-bold relative text-voxel-gray-700 hover:opacity-75 hover:no-underline group-hover:cursor-pointer"
                >
                  Sign up for free
                  <div className="absolute w-28 h-auto top-7 right-0 -rotate-3 text-voxel-gray-600">
                    <UnderlineScribble fill={'#52525b'} />
                  </div>
                </VoxelLink>
              </VoxelText>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden sm:block sm:col-span-2 lg:col-span-3 rounded-l-[128px] w-full h-screen bg-wavesStacked bg-cover bg-center" />
    </div>
  );
};

export default SignInPage;
